import withAuthentication from 'authentication/withAuthentication'
import LayoutRoute from './LayoutRoute'

export default withAuthentication(LayoutRoute)
